import { BoundaryRequest, InventoryApi, InventoryBoundary } from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { INVENTORIES_QUERY_KEYS } from './queryKeys'

export const useCreateBoundary = () => {
  const queryClient = useQueryClient()

  return useMutation<InventoryBoundary, AxiosError, { inventoryId: string; data: BoundaryRequest }>(
    ({ inventoryId, data }) => {
      return InventoryApi.createBoundary(inventoryId, data).then(d => d.data.item)
    },
    {
      onSuccess: (data: InventoryBoundary) => {
        queryClient.invalidateQueries([INVENTORIES_QUERY_KEYS.INVENTORIES, data.inventoryId])
        queryClient.setQueryData(
          [INVENTORIES_QUERY_KEYS.BOUNDARIES, data.inventoryId, data.boundaryId],
          { item: data }
        )
      },
    }
  )
}
